"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.decoratedHeaderStyles = void 0;
const headerVariantSettings = {
    mainBanner: {
        after: {
            xs: {
                top: -73.18,
                right: 4.24,
                size: 112
            },
            smUp: {
                top: -257,
                right: -13,
                size: 300
            }
        },
        before: {
            xs: {
                bottom: -50.39,
                left: -50.39,
                size: 106
            },
            smUp: {
                bottom: -179,
                left: -67,
                size: 234
            }
        }
    },
    offerHeader: {
        after: {
            xs: {
                right: -34.18,
                size: 142,
                top: -86.59
            },
            smUp: {
                right: -13,
                size: 300,
                top: -257
            }
        },
        before: {
            xs: {
                bottom: -110.15,
                left: -41.19,
                size: 142
            },
            smUp: {
                bottom: -179,
                left: -67,
                size: 234
            }
        }
    }
};
const getPositionStyles = (input)=>{
    const { size, ...rest } = input;
    return {
        ...rest,
        height: size,
        width: size
    };
};
const decoratedHeaderStyles = (theme, variant)=>{
    // positions for decoration bubbles in the background
    const { after, before } = headerVariantSettings[variant];
    const decorationStyles = {
        background: theme.palette.primary.main,
        borderRadius: '50%',
        boxSizing: 'border-box',
        content: '""',
        opacity: 0.15,
        position: 'absolute'
    };
    const base = {
        background: theme.palette.primary.light,
        boxSizing: 'border-box',
        color: theme.palette.text.primary,
        overflow: 'hidden',
        position: 'relative',
        '&::after': {
            ...decorationStyles,
            ...getPositionStyles(after.xs)
        },
        '&::before': {
            ...decorationStyles,
            ...getPositionStyles(before.xs)
        },
        [theme.breakpoints.up('sm')]: {
            '&::after': {
                ...getPositionStyles(after.smUp)
            },
            '&::before': {
                ...getPositionStyles(before.smUp)
            }
        }
    };
    const smUp = base[theme.breakpoints.up('sm')];
    return {
        base,
        smUp
    };
};
exports.decoratedHeaderStyles = decoratedHeaderStyles;
